import { render } from "./oauthDetail.vue?vue&type=template&id=1c74e7fe&scoped=true"
import script from "./oauthDetail.vue?vue&type=script&lang=js"
export * from "./oauthDetail.vue?vue&type=script&lang=js"

import "./oauthDetail.vue?vue&type=style&index=0&id=1c74e7fe&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c74e7fe"]])

export default __exports__